import { API_KEY_ID_CULTURE, API_KEY_NAME, AUTHORIZATION_NAME } from "@/main/services/storage";
import { getAPIAuthorization, getAPIPublicAccessKey, getCultureBrowser, isPublicAPI } from "@/main/services/utils";

const version = import.meta.env.VITE_API_VERSION;

class ApiFetch {
	private baseUrl: string;
	private headers: Headers;

	constructor() {
		this.baseUrl = `${import.meta.env.VITE_API_BASE_URL}api/${version}/`;
		this.headers = new Headers({
			"Access-Control-Allow-Origin": "*",
			"Content-Type": "application/json",
		});
	}

	private setTokenToRequestFetch(url: string) {
		if (isPublicAPI(String(url))) {
			this.headers.set(API_KEY_NAME, String(getAPIPublicAccessKey()));
			this.headers.set(API_KEY_ID_CULTURE, getCultureBrowser());
		} else {
			this.headers.set(AUTHORIZATION_NAME, getAPIAuthorization());
		}
	}

	async get(url: string) {
		this.setTokenToRequestFetch(url);
		const response = await fetch(this.baseUrl + url, {
			method: "GET",
			keepalive: true,
			headers: this.headers,
		});
		return response.json();
	}

	async post(url: string, body: any) {
		this.setTokenToRequestFetch(url);

		const response = await fetch(this.baseUrl + url, {
			method: "POST",
			keepalive: true,
			headers: this.headers,
			body: JSON.stringify(body),
		});
		return response.json();
	}

	async put(url: string, body: any) {
		this.setTokenToRequestFetch(url);

		const response = await fetch(this.baseUrl + url, {
			method: "PUT",
			keepalive: true,
			headers: this.headers,
			body: JSON.stringify(body),
		});
		return response.json();
	}
}

const apiFetch = new ApiFetch();

export { apiFetch, version };
